/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';

export default class IndexController extends Controller {
  @service
  session;

  @service
  features;

  @alias('features.controlPanelEnabled')
  controlPanelEnabled;
}
